import { render, staticRenderFns } from "./ServiesDetails.html?vue&type=template&id=3658c489&external"
import script from "./ServiesDetails.vue?vue&type=script&lang=js"
export * from "./ServiesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports